import { ColorPaletteColors } from '@nucleus/types/web';
import { nucleusClass, objectToCssClass, objectToCssRules } from '@nucleus/web-theme-elements';
import { DefaultTheme, Interpolation, ThemeProps, css } from 'styled-components';
import { buildCssVariablesForColorPaletteAndVariations, buildThemeColorsVariationClassName } from '../utils/styles';

export const getColorGlobalStyle = ({
  colorPalette,
}: {
  colorPalette: ColorPaletteColors;
}): Interpolation<ThemeProps<DefaultTheme>> => {
  const [globalCssVariables, colorCssVariables, colorCssVariablesByVariation] =
    buildCssVariablesForColorPaletteAndVariations(colorPalette);

  return css`
    :root {
      ${() => objectToCssRules(globalCssVariables)}

      ${() => objectToCssRules(colorCssVariables)}

      ${() => objectToCssRules(colorCssVariablesByVariation['variation-1'])}
    }

    /* output css variables grouped by theme colors variation class */
    ${() =>
      Object.entries(colorCssVariablesByVariation)
        .map(([key, value]) => objectToCssClass(buildThemeColorsVariationClassName(key), value))
        .join('')}

    .nucleus-section-header {
      &:has(+ .theme-colors-variation-1) {
        ${() => objectToCssRules(colorCssVariablesByVariation['variation-1'])}
      }

      &:has(+ .theme-colors-variation-2) {
        ${() => objectToCssRules(colorCssVariablesByVariation['variation-2'])}
      }

      &:has(+ .theme-colors-variation-3) {
        ${() => objectToCssRules(colorCssVariablesByVariation['variation-3'])}
      }

      &:has(+ .theme-colors-variation-4) {
        ${() => objectToCssRules(colorCssVariablesByVariation['variation-4'])}
      }

      &:has(+ section > .${nucleusClass('section-inset')}) {
        --color-section-text: var(--color-block-background);
        --color-logo-h: var(--color-block-background-h);
        --color-logo-s: var(--color-block-background-s);
        --color-logo-l: var(--color-block-background-l);
        --color-logo-a: var(--color-block-background-a);
        --color-logo: hsl(
          var(--color-logo-h),
          calc(var(--color-logo-s) * 1%),
          calc(var(--color-logo-l) * 1%),
          calc(var(--color-logo-a) * 1%)
        );
      }
    }
  `;
};
